import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'Root/App/Button'

library.add(faArrowDown)

const Download = ({ element }) => {
  return (
    <Button
      icon={<FontAwesomeIcon icon={['fas', 'arrow-down']} />}
      className="p-0 bg-gray-200 text-gray-500"
      size="S"
      subtype="circle"
      download={element.title}
      href={element.url}
    />
  )
}

export default Download
